/**
 * Registry of NaturePulse legal documents.
 *
 * A single source of truth used by:
 *   - /legal            (LegalHub – lists everything)
 *   - Footer            (Legal column – quick links)
 *   - Nav               (top-level Legal tab)
 *
 * When adding a new legal document:
 *   1. Add a new entry below.
 *   2. Add the corresponding <Route> in App.js.
 *   3. Optionally add to FOOTER_LEGAL_LINKS for the site footer.
 */
export const LEGAL_DOCS = [
  {
    slug: "terms",
    to: "/legal/terms",
    label: "Terms of Service",
    description:
      "The rules that govern your use of NaturePulse, Farmers Pulse and every service on the network.",
    updated: "August 24, 2026",
    kind: "internal",
  },
  {
    slug: "privacy",
    to: "/legal/privacy",
    label: "Privacy Policy",
    description:
      "What we collect, what we don't, and how we handle your observations, photos and account data.",
    updated: "August 23, 2026",
    kind: "internal",
  },
  {
    slug: "youth-privacy",
    to: "/about/youth-privacy",
    label: "Youth Privacy Policy",
    description:
      "How we protect contributors under 18 — steward-guarded, no ads, no tracking, EU AI Act aligned.",
    updated: "July 2026",
    kind: "internal",
  },
  {
    slug: "cookies",
    to: "/legal/cookies",
    label: "Cookie Policy",
    description:
      "How we use cookies and similar technologies, and the choices available to you.",
    updated: "August 23, 2026",
    kind: "internal",
  },
  {
    slug: "cookies-eu",
    to: "/legal/cookies-eu",
    label: "EU · EEA · UK Cookie Supplement",
    description:
      "Additional GDPR / ePrivacy consent rules for visitors from the EU, EEA and United Kingdom.",
    updated: "August 23, 2026",
    kind: "internal",
  },
  {
    slug: "ai",
    to: "/legal/ai",
    label: "AI Use & Agricultural Disclaimer",
    description:
      "Where AI assists across NaturePulse and Farmers Pulse — and where you shouldn't rely on it alone.",
    updated: "August 23, 2026",
    kind: "internal",
  },
  {
    slug: "user-content",
    to: "/legal/user-content",
    label: "User-Generated Content Policy",
    description:
      "Who owns what you upload, how NaturePulse may use it, and the responsibilities that come with contributing.",
    updated: "August 23, 2026",
    kind: "internal",
  },
  {
    slug: "community",
    to: "/legal/community",
    label: "Community Guidelines",
    description:
      "How the NaturePulse and Farmers Pulse community treats each other, wildlife and shared knowledge.",
    updated: "August 23, 2026",
    kind: "internal",
  },
  {
    slug: "research",
    to: "/legal/research",
    label: "Research & Data Use Policy",
    description:
      "How observations power citizen science — access levels, ethics, attribution and prohibited uses.",
    updated: "August 23, 2026",
    kind: "internal",
  },
  {
    slug: "copyright",
    to: "/legal/terms#copyright-complaints",
    label: "Copyright & DMCA",
    description:
      "How to report copyrighted material appearing on NaturePulse and how we respond. (Section of ToS.)",
    updated: "August 24, 2026",
    kind: "anchor",
  },
];

/** Compact list rendered inside the site footer's "Legal" column. */
export const FOOTER_LEGAL_LINKS = [
  { label: "Terms of Service",       to: "/legal/terms" },
  { label: "Privacy Policy",         to: "/legal/privacy" },
  { label: "Cookie Policy",          to: "/legal/cookies" },
  { label: "AI Disclaimer",          to: "/legal/ai" },
  { label: "Community Guidelines",   to: "/legal/community" },
  { label: "User-Generated Content", to: "/legal/user-content" },
  { label: "Research & Data",        to: "/legal/research" },
  { label: "Youth Privacy",          to: "/about/youth-privacy" },
  { label: "Copyright / DMCA",       to: "/legal/terms#copyright-complaints" },
  { label: "All legal notices",      to: "/legal" },
];
